import { Flex } from "antd"
import { Space, Title, Icon } from "components/common"
import styles from "./index.module.less"

import cx from "clsx"
import Container from "components/common/container/contianer"
import AppLink from "components/common/layout/app-link"
import {
  BayutAppStoreArabicIcon,
  BayutAppStoreIcon,
  BayutPlayStoreArabicIcon,
  PlayStoreBadgeIcon,
} from "components/svg"
import { useTranslation } from "react-i18next"
import { APPSTORE_URL, PLAYSTORE_URL } from "ksa/constants/appLinks"

const isMobile = window.innerWidth <= 640

const DownloadSection = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.theApp}>
      <Container className={styles.footerContainer}>
        <Title
          level={2}
          className="mbe-8"
          style={{ fontSize: isMobile ? "14px" : "24px", marginTop: !isMobile && "2.2rem" }}
        >
          {t("Download Our App")}
        </Title>
        <div
          className={cx(isMobile ? "mbe-16" : "mbe-20", styles.description)}
          style={{ color: "#222", fontSize: isMobile ? "10px" : "16px" }}
        >
          {t("get_app_search_properties")}
        </div>
        <Space align="start" style={{ "--ant-padding-xs": "18px" }}>
          <Flex vertical className="" align="center" gap="4px">
            <AppLink
              link={APPSTORE_URL}
              target={"_blank"}
              IconEn={BayutAppStoreIcon}
              IconAr={BayutAppStoreArabicIcon}
              width={"115"}
            />
            <AppLink
              link={PLAYSTORE_URL}
              target={"_blank"}
              IconEn={PlayStoreBadgeIcon}
              IconAr={BayutPlayStoreArabicIcon}
              width={"115"}
            />
          </Flex>

          {!isMobile && <Icon icon="BayutQRCode" size="80px" />}
        </Space>
      </Container>
    </div>
  )
}

export default DownloadSection
